export enum SkywardIntegrationTokenActions {
  None,
  Generate,
  Revoke,
}

export interface IIntegrationSecuritySettingsUpdate {
  AllowCustomerToSetSecret: boolean;
  SkywardIntegrationToken1Action: SkywardIntegrationTokenActions;
  SkywardIntegrationToken2Action: SkywardIntegrationTokenActions;
}
